/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CureCategory_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl + 'rest/cureCategories/:id',{}, {
            query: { method: 'GET', isArray: false },
            getTree: { method: 'GET', isArray: false , url:baseUrl+'rest/cureCategories/tree'},
            getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/cureCategories/deleted'},
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureCategory',["CureCategory_Resource","Cure","CureCategoryData","CureData","ImageData","CompanyImageData",
        function (CureCategory_Resource,Cure,CureCategoryData,CureData,ImageData,CompanyImageData)
    {
        var CureCategory = function (rsCureCategory,parentCategory)
        {
            this.id = null;
            this.isDeleted;
            this.label = "";
            this.description = "";
            this.image = null;
            this.companyImage = null;
            this.specificImage;//boolean
            this.isVisibleOnWebSite;
            this.style = "";
            this.cures = [];
            this.categories = [];
            this.parentCategoryId = null;
            this.version = null;

            if (parentCategory!==undefined && parentCategory!=null)
                this.parentCategory=  parentCategory;

            if (rsCureCategory!==undefined && rsCureCategory!=null)
            {
                var cure,category;
                if (!this.id)
                    this.id = rsCureCategory.id;
                this.isDeleted = rsCureCategory.isDeleted;
                this.label = rsCureCategory.label;
                this.description = rsCureCategory.description;
                this.imageId =  rsCureCategory.imageId;
                this.companyImageId =  rsCureCategory.companyImageId;
                this.specificImage = rsCureCategory.specificImage;
                this.isVisibleOnWebSite = rsCureCategory.isVisibleOnWebSite;
                this.parentCategoryId =  rsCureCategory.parentCategoryId;
                this.style = rsCureCategory.style;
                if (rsCureCategory.version)
                    this.version = rsCureCategory.version;

                if ( rsCureCategory.categories)
                    for (var i=0;i< rsCureCategory.categories.length;i++)
                    {
                        category = new CureCategory(rsCureCategory.categories[i],this);
                        this.categories.push(category);
                    }

                if ( rsCureCategory.cures)
                    for (var j=0;j< rsCureCategory.cures.length;j++)
                    {
                        cure = new Cure(rsCureCategory.cures[j],this);
                        this.cures.push(cure);
                    }
            }
            CureCategoryData.add(this);
        }

        CureCategory.prototype.loadObject = function(object,parentCategory)
        {
            this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.description = object.description;
            this.style= object.style;
            this.specificImage = object.specificImage;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;
            if (object.version)
                this.version = object.version;

            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory=  parentCategory;
            }

            //load ref from ids
            if (object.curesId)
            {
                var newCures = [];
                for (var i=0;i<object.curesId.length;i++)
                {
                    var cure =  CureData.getById(object.curesId[i]);
                    if (cure!=null)
                        newCures.push(cure);
                }
                this.cures = newCures;
            }
            if (object.curesId)
            {
                var newCategories = [];
                for (i=0;i<object.categoriesId.length;i++)
                {
                    var category =  CureCategoryData.getById(object.categoriesId[i]);
                    if (category!=null)
                        newCategories.push(category);
                }
                this.categories = newCategories;
            }


        }
        CureCategory.prototype.getObjectResource = function()
        {
            var rsCureCategory = new CureCategory_Resource();
            rsCureCategory.id = this.id ;
            rsCureCategory.isDeleted = this.isDeleted;
            rsCureCategory.label =this.label;
            rsCureCategory.description =this.description;
            if (this.image)
                rsCureCategory.imageId = this.image.id;
            if (this.companyImage)
                rsCureCategory.companyImageId = this.companyImage.id;
            rsCureCategory.specificImage = this.specificImage;
            rsCureCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsCureCategory.style = this.style;

            if (this.parentCategory)
                rsCureCategory.parentCategoryId = this.parentCategory.getId();
            rsCureCategory.categoriesId = [];
            for (var i=0;i< this.categories.length;i++)
                rsCureCategory.categoriesId.push( this.categories[i].getId());
            rsCureCategory.curesId = [];
            for (var i=0;i< this.cures.length;i++)
                rsCureCategory.curesId.push(this.cures[i].getId());
            return rsCureCategory;
        }
        CureCategory.prototype.getId = function()
        {
            return this.id;
        }
        CureCategory.prototype.setId = function(id)
        {
            this.id = id;
        }
        CureCategory.prototype.getLabel = function()
        {
            return this.label;
        }
        CureCategory.prototype.addCure = function(cure)
        {
            var index = this.cures.indexOf(cure);
            if (index==-1)//Not already there
            {
                this.cures.push(cure);
                cure.parentCategory = this;
            }
        }
        CureCategory.prototype.removeCure = function(cure)
        {
            var index = this.cures.indexOf(cure);
            if (index!=-1)//Found
            {
                this.cures.splice(index,1);
            }

        }
        CureCategory.prototype.addCategory = function(category)
        {
            if (category) {
                var index = this.categories.indexOf(category);
                if (index == -1)//Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
            }
        }
        CureCategory.prototype.removeCategory = function(category)
        {
            var index = this.categories.indexOf(category);
            if (index!=-1)//Found
            {
                this.categories.splice(index,1);
            }

        }        
        CureCategory.prototype.changeCurePosition = function(cure,indexTarget)
        {
            //Change the cure position
            var index = this.cures.indexOf(cure);
            if (indexTarget!=-1 && index!=-1 && indexTarget!=index && this.cures && indexTarget<this.cures.length)
            {
                var cat = this.cures[indexTarget];

                this.cures.splice(index,1);
                if (index<indexTarget)
                    indexTarget--;
                this.cures.splice(indexTarget,0,cure);

            }

        }
        CureCategory.prototype.getCureById =  function(cureId)
        {
            //recursive research
            var cure = null;
            for (var j = 0; j < this.cures.length; j++)
                if (this.cures[j].id == cureId)
                    return this.cures[j];
            for (var z=0;z< this.categories.length && !cure;z++)
                cure = this.categories[z].getCureById(cureId);

            return cure;
        }
        CureCategory.prototype.getCureByLabel =  function(cureLabel)
        {
            //recursive research, need lower case input
            var cure = null;
            for (var j = 0; j < this.cures.length; j++)
                if (this.cures[j].label.toLowerCase() == cureLabel)
                    return this.cures[j];
            for (var z=0;z< this.categories.length && !cure;z++)
                cure = this.categories[z].getCureByLabel(cureLabel);

            return cure;
        }
        CureCategory.prototype.getCureCategoryById =  function(categoryId)
        {
            //recursive research
            var category = null;
            for (var z=0;z< this.categories.length && !category;z++)
                if (this.categories[z].id == categoryId)
                    category= this.categories[z];
                else
                    category = this.categories[z].getCureCategoryById(categoryId);
            return category;
        }
        CureCategory.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = CureCategoryData.getById(this.parentCategoryId);
        }

        CureCategory.prototype.getSubStatCategories =  function(rootCategory)
        {
            return this.categories.concat(this.cures);
        }

        CureCategory.prototype.isDescendantOf = function(category) {
            var isDescendantOf = false;
            if(this.parentCategory === category) {
                isDescendantOf = true;
            }
            else {
                if(this.parentCategory) {
                    isDescendantOf = this.parentCategory.isDescendantOf(category);
                }
            }

            return isDescendantOf;
        }

        return CureCategory;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureCategorySrv',["CureCategory_Resource","CureCategory","CureCategoryData","UserActionData","CureSrv","$log","ServerSrv",
        function (CureCategory_Resource,CureCategory,CureCategoryData,UserActionData,CureSrv,$log,ServerSrv)
    {
        //$timeout (function () {

        var  categorySrv = {};
        categorySrv.query = function(successFunction,errorFunction)
        {
            var treeLoaded = false;
            var deletedLoaded = false;
            CureCategory_Resource.getTree(
                {}, //params
                function (data) {   //success
                    CureCategoryData.categoryRoot = new CureCategory(data);

                    if (successFunction !== undefined && deletedLoaded)
                        successFunction(CureCategoryData.categoryRoot);
                    treeLoaded = true;
                },
                function (data) {   //failure
                    $log.error("CureCategory_Resource.getTree error");
                    $log.error(data);
                    if (errorFunction!== undefined && deletedLoaded)
                        errorFunction(data);
                    treeLoaded = true;
                });
            CureCategory_Resource.getDeleted(
                {}, //params
                function (data) {   //success
                    CureCategoryData.deletedCategories = [] ;
                    for (var i=0;i< data.length;i++)
                        new CureCategory(data[i]);//Auto Add to CureCategoryData

                    if (successFunction!== undefined && treeLoaded)
                        successFunction(CureCategoryData.categoryRoot);
                    deletedLoaded = true;
                },
                function (data) {   //failure
                    $log.error("CureCategory_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined && treeLoaded)
                        errorFunction(data);
                    deletedLoaded = true;

                }
            );
        };
        categorySrv.save = function(category,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
        };
        categorySrv.saveSync = function(category,successFunction,errorFunction)
        {
            var CureCategoryRes = category.getObjectResource();
            CureCategoryRes.$save({}, //no params
                function (data) {
                    try {
                        category.setId(data.id);
                        //TODO  UserActionData.add(data.userAction);
                        if (successFunction) {
                            successFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        categorySrv.remove =  function(category,successFunction,errorFunction)
        {
            CureCategoryData.remove(category);
            ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
        };
        categorySrv.removeSync =  function(category,successFunction,errorFunction)
        {
            var categoryRes = new CureCategory_Resource()
            categoryRes.$remove({id:category.getId()}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        categorySrv.restore =  function(category,successFunction,errorFunction)
        {
            CureCategoryData.restore(category);
            ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
        };
        categorySrv.restoreSync =  function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var categoryRes = category.getObjectResource();
            categoryRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.getCureCategoryOnServer =  function(scope,targetName,categoryId)
        {

            var category = null
            if (CureCategoryData.categoryRoot.categories!=null && CureCategoryData.categoryRoot.categories.length>0)
            {
                for (var i=0;i<CureCategoryData.categoryRoot.categories.length && !category;i++)
                    if (CureCategoryData.categoryRoot.categories[i].getId()==categoryId)
                        category = CureCategoryData.categoryRoot.categories[i];
                    else
                        for (var j=0;j<CureCategoryData.categoryRoot.categories[i].categories.length && !category;j++)
                            if (CureCategoryData.categoryRoot.categories[i].categories[j].getId()==categoryId)
                                category = CureCategoryData.categoryRoot.categories[i].categories[j];

                scope[targetName] =  category;
            }
            else
            {

                CureCategory_Resource.get(
                    {id:categoryId},
                    function (categoryRes) {   //success
                        var bookingCures = [];
                        scope[targetName] = new CureCategory(categoryRes);
                    },
                    function (categoryRes) {   //failure
                        //error handling goes here
                    });
            }
        };
        categorySrv.get =  function(categoryId)
        {
            //TODO
            return null;
        };
        categorySrv.getCureById =  function(cureId)
        {
            if (CureCategoryData.categoryRoot!=null)
            return CureCategoryData.categoryRoot.getCure(cureId);
        };
        categorySrv.loadRef =  function()
        {
            var categories = CureCategoryData.indexCategories;
            for (var i=0;i<categories.length;i++)
                categories[i].loadRef();

        };
        categorySrv.moveCure = function(category,cure)
        {
            if (category)
            {
                category.moveCure(cure);
                CureSrv.save(cure);

            }
        };
        categorySrv.updateLocally =  function(id,object)
        {
            var category = null;
            var parentCategory = null;
            if (object.parentCategoryId)//Optimization : get parent if exist
            {
                parentCategory = CureCategoryData.getById(object.parentCategoryId);
                if  (parentCategory!=null)
                    category = parentCategory.getCureCategoryById(id);
            }
            else
                category = CureCategoryData.getById(id);
            if (category!=null)
                category.loadObject(object,parentCategory);
        };
        categorySrv.addLocally =  function(object)
        {
            //TODO
/*            var category = CureCategoryData.getCureCategory(object.parentCategoryId);
            if (category!=null)
                category.addCure(new Cure(object,category));*/

        };
        categorySrv.removeLocally =  function(object)
        {
            //TODO
/*            var cure =  null;
            var category = CureCategoryData.getCureCategory(object.parentCategoryId);
            if (category!=null)
                cure = category.getCure(object.id)
            if (cure!=null)
                category.removeCure(cure);*/
        };

        return categorySrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureCategoryData',["$log", function ($log)
    {
        var  categoryData = 
        {
            categoryRoot : null,
            indexCategories : [], //Used as Index
            deletedCategories : []
        };
        categoryData.getById =  function(categoryId)
        {
            for (var i=0;i<this.indexCategories.length;i++)
                if (this.indexCategories[i].id==categoryId)
                    return this.indexCategories[i];
            return null;
        }
        categoryData.getByIndex =  function(catIndex)
        {
            if (catIndex>=0 && catIndex<this.indexCategories.length)
                return this.indexCategories[catIndex];
            else
                return null;
        }
        categoryData.getIndexOf =  function(category)
        {
            if (category)
                return this.indexCategories.indexOf(category);
            return -1;
        }
        categoryData.add =  function(category)
        {
            this.indexCategories.push(category);
            if (category.isDeleted)
            {
                var index = this.deletedCategories.indexOf(category)
                if (index==-1)
                    this.deletedCategories.push(category);
            }
            return this.indexCategories.length-1;
        }
        categoryData.remove =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index==-1)
            {
                this.deletedCategories.push(category)
                category.isDeleted=true;
            }

        }
        categoryData.restore =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index!=-1)
            {
                this.deletedCategories.splice(index,1)
                category.isDeleted=false;
            }

        }
        categoryData.clear =  function()
        {
            categoryData.categoryRoot = null;
            categoryData.indexCategories = [];
            categoryData.deletedCategories = [];
        }
        categoryData.loaded =  function()
        {
            return (categoryData.categoryRoot != null);
        }
        categoryData.getDeletedList =  function()
        {
            return categoryData.deletedCategories;
        }

        return categoryData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/CureCategory.js